export default __webpack_public_path__ + "static/media/MN.15ef7138.svg";